export default "__VITE_ASSET__CcIGXvHU__"